import { render, staticRenderFns } from "./CityFamilyAccount.vue?vue&type=template&id=6b40dfe6&scoped=true&"
import script from "./CityFamilyAccount.vue?vue&type=script&lang=js&"
export * from "./CityFamilyAccount.vue?vue&type=script&lang=js&"
import style0 from "./CityFamilyAccount.vue?vue&type=style&index=0&id=6b40dfe6&prod&lang=css&"
import style1 from "./CityFamilyAccount.vue?vue&type=style&index=1&id=6b40dfe6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b40dfe6",
  null
  
)

export default component.exports